export default [ {
  path: '/pintuan',
  name: 'pintuan',
  redirect: {
    name: 'pintuanList'
  },
  meta: {
    title: '天天拼团',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/pintuan/index'], resolve)
  },
  children: [{
    path: 'list',
    name: 'pintuanList',
    meta: {
      title: '商品列表',
      NeedLogin: false,
      keepAlive: false
    },
    component: resolve => {
      require(['../views/pintuan/list'], resolve)
    }
  }, {
    path: 'orderlist',
    name: 'pintuanOrderList',
    meta: {
      title: '我的订单',
      NeedLogin: false,
      keepAlive: false
    },
    component: resolve => {
      require(['../views/pintuan/orderlist'], resolve)
    }
  }, {
    path: 'detail/:id',
    name: 'pintuanDetail',
    meta: {
      title: '商品详情',
      NeedLogin: false,
      keepAlive: false
    },
    component: resolve => {
      require(['../views/pintuan/detail'], resolve)
    }
  }, {
    path: 'order/:id/:type/:groupid',
    name: 'pintuanOrder',
    meta: {
      title: '确认订单',
      NeedLogin: false,
      keepAlive: false
    },
    component: resolve => {
      require(['../views/pintuan/orderconfirm'], resolve)
    }
  }, {
    path: 'orderdetail/:id',
    name: 'pintuanOrderDetail',
    meta: {
      title: '订单详情',
      NeedLogin: false,
      keepAlive: false
    },
    component: resolve => {
      require(['../views/pintuan/orderdetail'], resolve)
    }
  }, {
    path: 'rule',
    name: 'pintuanRule',
    meta: {
      title: '活动规则',
      NeedLogin: false,
      keepAlive: false
    },
    component: resolve => {
      require(['../views/pintuan/rule'], resolve)
    }
  }, {
    path: 'share/:shareid/:groupid',
    name: 'pintuanShare',
    meta: {
      title: '超值团购',
      NeedLogin: false,
      keepAlive: false
    },
    component: resolve => {
      require(['../views/pintuan/share'], resolve)
    }
  }]
}]
